export default function IconHeart({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M20.7301 5.095C20.2299 4.59978 19.6437 4.19991 19.0001 3.915C18.0075 3.50251 16.9147 3.39445 15.8606 3.60457C14.8065 3.81468 13.8386 4.33347 13.0801 5.095L12.0001 6.145L11.0001 5.095C9.98164 4.07657 8.60035 3.50442 7.16007 3.50442C5.71979 3.50442 4.3385 4.07657 3.32007 5.095C2.30164 6.11343 1.72949 7.49472 1.72949 8.935C1.72949 10.3753 2.30164 11.7566 3.32007 12.775L4.37007 13.825L12.0001 21.505L19.6801 13.825L20.7301 12.775C21.2326 12.2694 21.6332 11.6719 21.9101 11.015C22.4569 9.68223 22.4569 8.18776 21.9101 6.855C21.6308 6.19939 21.2305 5.6023 20.7301 5.095V5.095Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
